import store from "../util/store.jsx";
import {ProfileView} from "../views/profileView.jsx"
import { signOut } from "firebase/auth";
import { auth } from "../util/firebaseAuth.js";
import locationTask from "../data/locationTask.json";
import images from "../images/images.js";
import { useParams } from "react-router-dom";

function Profile() {
  const { id } = useParams();
  
  const state = store.getState();
  const { firstName, lastName, email, Uid } = state.userData.userProfile;
  const userScore = state.userData.userProgress.score;


  
  const checkpointsData = state.userData.userProgress.stockholm || {};
  const visitedCheckpoints = Object.keys(checkpointsData).filter((cpId) => {
    return Object.keys(checkpointsData[cpId]).length > 0;
  });
  const checkpointCount = visitedCheckpoints.length;
  const checkpointList = visitedCheckpoints.map((cpId) => {
    const cpData = checkpointsData[cpId];
    let successCount = 0;
    Object.keys(cpData).forEach((mode) => {
      const modeData = cpData[mode];
      Object.values(modeData).forEach((quest) => {
        if (quest.status === "success") {
          successCount++;
        }
      });
    });
    const progressForCp = Math.round((successCount / 8) * 100);
    const title = (locationTask[cpId] && locationTask[cpId].title) ? locationTask[cpId].title : cpId;
    const image = images[`picture_${cpId}`];
    return { id: cpId, progressPercentage: progressForCp, name: title, image };
  });

  const completedQuests = Object.values(checkpointsData).reduce((acc, cpData) => {
    Object.keys(cpData).forEach((mode) => {
      const modeData = cpData[mode];
      Object.values(modeData).forEach((quest) => {
        if (quest.status === "success") {
          acc++;
        }
      });
    });
    return acc;
  }, 0);

  function handleLogoutACB() {
    signOut(auth)
      .then(() => {
        console.log("User logged out");
        
        store.dispatch({ type: "LOGOUT" });
        
        window.location.hash = "#/";
      })
      .catch((error) => {
        console.error("Logout error:", error);
        alert("Failed to log out.");
      });
  }
  
  const progressPercentage = Math.min(Math.round((userScore / 1000) * 100), 100);

function GotoCheckPointACB(cpId) {
  window.location.hash = `#/checkpoint/${cpId}`;
}
  
  return <ProfileView 
    firstName={firstName} 
    lastName={lastName} 
    email={email}  
    Uid={Uid}
    userScore={userScore}
    progressPercentage={progressPercentage}
    checkpointCount={checkpointCount}
    completedQuests={completedQuests} 
    checkpointList={checkpointList}
    onLogOut={handleLogoutACB}
    onGotoCheckPoint={GotoCheckPointACB}
  />;
}

export { Profile };